import React from "react";
import { Box, Flex, Icon, Stack, Text } from "@chakra-ui/react";
import { MdStorage } from "react-icons/md";
import StatusChipIndicator from "./StatusChipIndicator";
import { useSectionColors } from "./statusCardStyles";

/**
 * Displays the optimized index status: existence chip and document count.
 * @param {object} props
 * @param {object|null} props.elasticsearch - Elasticsearch status data from API
 * @returns {React.ReactElement}
 */
function OptimizedIndexSection({ elasticsearch }) {
    const { boxBg, label, value, title } = useSectionColors();
    return (
        <Box>
            <Flex align="center" gap="8px" mb="12px">
                <Icon as={MdStorage} w="20px" h="20px" color="purple.500" />
                <Text fontSize="md" fontWeight="600" color={title}>Optimized Index</Text>
            </Flex>
            <Box p="14px" bg={boxBg} borderRadius="12px">
                <Stack spacing="10px">
                    <Flex justify="space-between" align="center">
                        <Text fontSize="sm" color={label}>Status</Text>
                        <StatusChipIndicator isActive={elasticsearch?.optimized_index_exists}
                            activeLabel="Exists" inactiveLabel="Missing" />
                    </Flex>
                    <Flex justify="space-between" align="center">
                        <Text fontSize="sm" color={label}>Documents</Text>
                        <Text fontSize="lg" fontWeight="700" color={value}>{elasticsearch?.optimized_document_count || 0}</Text>
                    </Flex>
                </Stack>
            </Box>
        </Box>
    );
}

export default OptimizedIndexSection;
